import { CopyItem } from '@/components/valuePropList';

import messages from '../../Handoff/messages';

export const spotifyValueProps: Array<CopyItem> = [
	{ body: messages.contentInMinutes, id: 'Content in Minutes' },
	{ body: messages.contentWithCelebs, id: 'Content with Celebs' },
	{ body: messages.goals, id: 'Goals' },
	{ body: messages.motivation, id: 'Motivation' },
];
